"use strict";

exports.__esModule = true;
exports.PROPERTY_PREFIX = exports.ATTRIBUTE_PREFIX = void 0;
exports.dataAttr = dataAttr;
exports.dataProp = dataProp;
var ATTRIBUTE_PREFIX = exports.ATTRIBUTE_PREFIX = "data-rr-ui-";
var PROPERTY_PREFIX = exports.PROPERTY_PREFIX = "rrUi";
function dataAttr(property) {
  return "".concat(ATTRIBUTE_PREFIX).concat(property);
}
function dataProp(property) {
  return "".concat(PROPERTY_PREFIX).concat(property);
}